import { dictionaries, type Locale } from './i18n/index.js';

/**
 * LEGAL-001 — the privacy policy and the terms of use.
 *
 * They are read straight out of the locale dictionaries rather than through
 * i18next, for the same reason `landingCopy` is: the text is a nested
 * structure, not a string, and `t()` returns strings. Reading the dictionary
 * directly also means the server can quote the same document — a sign-up mail,
 * a data-request reply — without a second copy drifting out of step.
 */
export const LEGAL_DOCUMENTS = ['privacy', 'terms', 'deleteAccount'] as const;
export type LegalDocumentKind = (typeof LEGAL_DOCUMENTS)[number];

export interface LegalSection {
  heading: string;
  body: readonly string[];
}

export interface LegalDocument {
  kind: LegalDocumentKind;
  title: string;
  intro: string;
  updated: string;
  contact: string;
  sections: readonly LegalSection[];
}

export function legalDocument(kind: LegalDocumentKind, locale: Locale): LegalDocument {
  const legal = dictionaries[locale].legal;
  const document = legal[kind];
  return {
    kind,
    title: document.title,
    intro: document.intro,
    updated: legal.updated,
    contact: legal.contact,
    sections: document.sections,
  };
}
